var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center gap-1",attrs:{"disabled":!_vm.upgradeAvailable},on:{"click":function($event){return _vm.upgrade()}}},[_vm._t("default"),(_vm.upgradeAvailable && _vm.showIcon)?_c('icon-arrow-up-bold',{attrs:{"width":"16","height":"16"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }